import { Role } from '@guiker/permissions'

import { AdminRoleNames } from './role-names'

export const PaymentAdmin: Role = {
  name: AdminRoleNames.PAYMENT_ADMIN,
  permissions: [{ action: 'payment:*' }],
}
